module.exports = __webpack_public_path__ + "img/coosa-valley-logo.d1e1924c.jpg";